export function LogRoutes(routes) {
    console.log(routes.map(function (route) { return route.pathMatcher.path; }));
}
//# sourceMappingURL=log-routes.js.map